import { Component, Output, EventEmitter } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { BsDropdownModule } from 'ngx-bootstrap/dropdown';
import { ButtonsAngularModule } from 'rev-shared/ui/buttons/ButtonsAngular.Module';
import { PieChartModule } from 'rev-shared/ui/dataVisualization/pieChart/PieChart.Module';
import { TranslateModule } from '@ngx-translate/core';
import { VbDropdownMenuModule } from 'rev-shared/ui/dropdown-menu/VbDropdownMenu.Module';
import { VbUiTooltipComponent } from 'rev-shared/ui/tooltip/VbUiTooltip.Component';

import { VbPollCardComponent } from './VbPollCard.Component';

@Component({
	selector: 'vb-manage-poll-card',
	templateUrl: './VbManagePollCard.Component.html',
	imports: [
		BsDropdownModule,
		ButtonsAngularModule,
		CommonModule,
		FormsModule,
		PieChartModule,
		TranslateModule,
		VbDropdownMenuModule,
		VbUiTooltipComponent
	],
	host: {
		'[class.poll-card]': 'true'
	},
	styleUrls: ['./VbPollCard.ng.less', '../WebcastSidebar.ng.less'],
})
export class VbManagePollCardComponent extends VbPollCardComponent {
	@Output() public pollEdited: EventEmitter<{ isNew?: boolean }> = new EventEmitter<{ isNew?: boolean }>();
	@Output() public pollDeleted: EventEmitter<void> = new EventEmitter<void>();
}
